import { IconText, SkeletonBox } from '@apeiron/temp'
import { styled, Typography } from '@mui/material'
import { useGuildChangeContext } from '@src/contexts/guild/GuildChangeContext'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'

const Container = styled(SkeletonBox)`
  align-items: center;
  background-color: #20334d;
  border-radius: 2px;
  border: 1px solid #267ff8;
  column-gap: 20px;
  display: flex;
  flex-wrap: wrap;
  padding: 4px 10px;
  row-gap: 5px;
  width: fit-content;
  &.Custom-Skeleton {
    height: 46px;
    width: 200px;
  }
`

const Title = styled(Typography)`
  font-size: 16px;
  font-weight: 400;
  line-height: 16px;
`

const GuildLabel = styled(IconText)`
  color: #908f90;
  gap: 5px;
  .Custom-Text {
    font-size: 12px;
    font-weight: 300;
  }
  .Custom-Icon {
    aspect-ratio: 1;
    width: 28px;
  }
`

const GuildJoined: FC<Props> = (props: Props) => {
  const { className } = props

  const { myGuild, fetchMyGuildLoading } = useGuildChangeContext()

  const { t } = useTranslation()

  return (
    <Container loading={fetchMyGuildLoading} className={className}>
      <Title>{t('guild.current_guild')}</Title>
      <GuildLabel
        startSrc={myGuild?.icon || ''}
        text={myGuild?.name || t('battle_demo.not_in_guild_popup')}
      />
    </Container>
  )
}

type Props = {
  className?: string
}

export default GuildJoined
